import React, { Component } from 'react';
import { ProgressBar } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { ApolloError } from 'apollo-client';
import ProfileIcon from '../../../components/ProfileIcon';
import RewardIcon from '../../../components/RewardIcon';
import LoadingIndicator from '../../../components/LoadingIndicator/index';
import {
  formatNumber,
  formatMoney,
  precisionRound
} from '../../../utils/functions';
import { userShape, patronStatusShape } from '../../../utils/shapes';
import { REWARD_TYPE } from '../../../utils/rewards';
import './ProfileLoyaltyInfo.css';

class ProfileLoyaltyInfo extends Component {
  doRender(user, patronAssets, status) {
    let pointsToNextTier = status.pointsNeeded;
    let points = status.basePointsEarned;
    let pointsBalance = status.basePoints;
    let rewardTier = status.clubState;
    let nextRewardTier = status.nextClubState ? status.nextClubState : ''; // null on unknown user and already max level
    let firstName = status.firstName ? status.firstName : user.displayName;
    let lastName = status.lastName;
    let freePlay = precisionRound(status.freePlay, 2) * 100;
    let rewardTierMax = pointsToNextTier + points - 1;

    let progressInfo, progressPerc;
    if (nextRewardTier === '') {
      if (rewardTier === '') {
        // no data
        progressInfo = (
          <div>
            Welcome to Wind Creek Casino! Your account is still being processed.
            Please check back soon!
          </div>
        );
        progressPerc = 0;
      } else {
        // top tier
        progressInfo = (
          <div>
            You are a <span className="reward-card-name">
              {rewardTier}
            </span>{' '}
            card member, our premier rewards tier with exclusive benefits!
          </div>
        );
        progressPerc = 100.0;
      }
    } else {
      // not top tier
      progressInfo = (
        <div>
          <div>Earn {formatNumber(pointsToNextTier)} points to upgrade to:</div>
          <div className="reward-card-name">{nextRewardTier} card</div>
        </div>
      );
      // don't use rewardTierMin because only points reset, not level.
      // but minimum for next level is still the same.
      progressPerc = 100.0 * points / rewardTierMax;
    }

    let tierClass = 'tier-' + rewardTier.toLowerCase();

    return (
      <div className="profile-loyalty-info-wrapper">
        <div className={`profile-loyalty-info ${tierClass}`}>
          <div className="profile-icon-wrapper">
            <ProfileIcon
              src={user && user.avatarUrl}
              size={120}
              border="border"
            />
          </div>
          <div className="name-row">
            <div className="user-full-name">
              {firstName.split(' ')[0].toLowerCase()} {lastName.toLowerCase()}
            </div>
            <div className="base-progress">Total Points YTD: {points}</div>
            <div>Rewards Account #{status.patronAccountNumber}</div>
          </div>
          <div className="progress-row">
            {progressInfo}
            <ProgressBar now={progressPerc} />
          </div>
          <div className="info-grid">
            <div className="base-points-row">
              <div>Points Balance</div>
              <div>{formatNumber(pointsBalance)}</div>
            </div>
            <div className="free-play-row">
              <div>
                <RewardIcon type={REWARD_TYPE.FREE_PLAY} size={30} /> Free Play
              </div>
              <div>{formatMoney(freePlay)}</div>
            </div>
            <div className="tickets-row">
              <div>Tickets</div>
              <div>{formatNumber(patronAssets.tickets)}</div>
            </div>
            <div className="w-score-row">
              <div>W Score</div>
              <div>{formatNumber(patronAssets.wscore)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      img,
      user,
      patronAssets,
      status,
      userAssets = { freePlay: 0.0, shoppingDollars: 0.0 },
      loading,
      error
    } = this.props.data;

    if (loading) {
      return <LoadingIndicator expand />;
    } else if (error) {
      return <div className="alert alert-danger">Failed to retrieve player info.  If this continues, please contact support.</div>;
    } else {
      return this.doRender(user, patronAssets, status);
    }
  }
}

ProfileLoyaltyInfo.propTypes = {
  data: PropTypes.shape({
    patronAssets: PropTypes.shape({
      points: PropTypes.number,
      tickets: PropTypes.number,
      wscore: PropTypes.number
    }),
    user: userShape,
    status: patronStatusShape
  }),
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.instanceOf(ApolloError),
    PropTypes.instanceOf(Error),
    PropTypes.bool
  ])
};

const patronLoyaltyQuery = gql`
  query {
    patronAssets {
      points
      tickets
      wscore
    }
    user {
      userId
      email
      userName
      displayName
      avatarUrl
      isAdmin
    }
    status {
      patronAccountNumber
      firstName
      lastName
      clubState
      nextClubState
      pointsNeeded
      basePoints
      basePointsEarned
      freePlay
      shoppingDollars
    }
  }
`;

const PatronLoyaltyWithData = graphql(patronLoyaltyQuery)(ProfileLoyaltyInfo);

export default PatronLoyaltyWithData;



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/ProfileLoyaltyInfo/index.js